import '@/index.css';
import '@fontsource-variable/open-sans';
// Side-effect import: initialises i18next before any component renders, so the
// very first paint is already in the resolved language.
import '@/lib/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';

// Send the http-only session cookie on every API request (same-origin per
// tenant subdomain; also required if any call is cross-origin).
axios.defaults.withCredentials = true;

// Axios default serializes arrays as `key[]=a&key[]=b`; NestJS expects `key=a&key=b`.
axios.defaults.paramsSerializer = (params: Record<string, unknown>) => {
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) {
      continue;
    }
    if (Array.isArray(value)) {
      for (const item of value) {
        sp.append(key, String(item));
      }
    } else {
      sp.set(key, String(value));
    }
  }
  return sp.toString();
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
